import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=5c0c4e2b&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"
import style0 from "./ThemeToggle.vue?vue&type=style&index=0&id=5c0c4e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c4e2b",
  null
  
)

export default component.exports